// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1nuxf","unreadBadge":"styles_unreadBadge__2gwD7","modalContent":"styles_modalContent__1hdKv","modal":"styles_modal__2BI9D"};